import type * as Types from '../../../__generated__/bffGlobalTypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetSessionDataVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSessionData = {
  session: {
    __typename?: 'Session',
    logged_in: boolean,
    human: {
      __typename?: 'SessionHuman',
      email: string,
      first_name: string | null,
      full_name: string,
      has_resale_closing_dashboard: boolean,
      has_partnership_referral_dashboard: boolean,
      has_partnership_developer_dashboard: boolean,
      id: number
    } | null
  } | null
};


export const GetSessionDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSessionData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"human"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"has_resale_closing_dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"has_partnership_referral_dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"has_partnership_developer_dashboard"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logged_in"}}]}}]}}]} as unknown as DocumentNode<GetSessionData, GetSessionDataVariables>;